module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f074dd_banner_800x600.bd9eb226.png";